import Icon from 'atomic/icon';
import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from '@ecommerce/nest-ssr/common';
import { ProductViewActions } from '../../../../shared/reducers/category-listing-type.reducer';
import { ListingType, ListingTypesEnum } from 'modules/shared/modules/categories-shared/interfaces/category-listing-config.interface';

import './product-view-type.scss';

const ProductViewType: React.FC<{ pageTypeName: string;}> = ({ pageTypeName }): ReactElement | null => {
    const dispatch = useDispatch();
    const currentListingType = useSelector((state: { listingType: ListingType; }) => state.listingType ?? ListingTypesEnum.List);

    const handleChange = (action: ProductViewActions): void => {
        dispatch({ type: action, payload: { pageTypeName } });
    };

    if (currentListingType === ListingTypesEnum.Lifestyle) {
        return null;
    }

    return (
        <div className="view-type">
            <Icon
                data-cy="view-type--list"
                className={classNames({
                    'view-type--line': true,
                    'view-type__selected-type': currentListingType === ListingTypesEnum.List
                })}
                name="lines"
                onClick={(): void => handleChange(ProductViewActions.list)}
                size={28}
            />
            <Icon
                data-cy="view-type--grid"
                className={classNames({
                    'view-type--grid': true,
                    'view-type__selected-type': currentListingType === ListingTypesEnum.Grid
                })}
                name="grid3"
                onClick={(): void => handleChange(ProductViewActions.grid)}
                size={28}
            />
        </div>
    );
};

export default ProductViewType;
